'use client';
import { Button } from '@heroui/button';
import { Image } from '@heroui/image';
import { Link } from '@heroui/link';
import { motion } from 'framer-motion';
import CountUp from 'react-countup';

export default function About() {
  return (
    <>
      <section className="relative section-md border-divider bg-background ">
        <div className="container container-max">
          <div className="grid justify-between items-center w-full grid-cols-1 gap-8 xl:gap-28 lg:grid-cols-2">
            <div className="inline-flex flex-col items-center justify-center w-full gap-8 lg:items-start">
              <div className="flex flex-col items-start justify-center w-full gap-12">
                <div className="flex flex-col items-center justify-start gap-4 lg:items-start">
                  <div className="flex flex-col items-center justify-start w-full gap-10 lg:items-start">
                    <motion.h2
                      initial={{ opacity: 0, y: -50 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5, delay: 0.4, ease: 'easeOut' }}
                      viewport={{ once: true }}
                      className="font-bold leading-normal text-center title text-primary lg:text-start"
                    >
                      About PayStop
                    </motion.h2>
                    <motion.p
                      initial={{ opacity: 0, y: -50 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{
                        duration: 0.5,
                        delay: 0.5,
                        ease: 'easeOut',
                      }}
                      viewport={{ once: true }}
                      className="text-base font-normal leading-relaxed text-center text-foreground lg:text-start"
                    >
                      PayStop allows individuals and businesses to facilitate banking transactions
                      for customers through local agents. Super Agents manage networks of agents,
                      while Sub-Agents support local banking operations like deposits, withdrawals,
                      and transfers.
                    </motion.p>{' '}
                  </div>
                </div>
                {/* <div className="flex flex-col items-start justify-center w-full gap-6">
                  <motion.div
                    initial={{ opacity: 0, y: -50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{
                      duration: 0.5,
                      delay: 0.6,
                      ease: 'easeOut',
                    }}
                    viewport={{ once: true }}
                    className="inline-flex items-center justify-center w-full gap-5 lg:justify-start sm:gap-10"
                  >
                    <div className="inline-flex flex-col items-start justify-start">
                      <CountUp
                        className="font-bold leading-normal title-md text-foreground"
                        duration={5}
                        end={5000}
                      />

                      <h6 className="text-base font-normal leading-relaxed text-foreground/70">
                        Active Agents
                      </h6>
                    </div>

                    <div className="inline-flex flex-col items-start justify-start">
                      <CountUp
                        className="font-bold leading-normal title-md text-foreground"
                        duration={5}
                        end={1400}
                      />

                      <h6 className="text-base font-normal leading-relaxed text-foreground/70">
                        Happy Customers
                      </h6>
                    </div>
                  </motion.div>
                </div> */}
              </div>
              <motion.div
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.5,
                  delay: 0.5,
                  ease: 'easeOut',
                }}
                viewport={{ once: true }}
              >
                {' '}
                <Button color="primary" radius="full" as={Link} href="/about-us">
                  Read More
                </Button>
              </motion.div>
            </div>
            <div className="flex items-start justify-center w-full lg:justify-start">
              <motion.div
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.5,
                  delay: 0.6,
                  ease: 'easeOut',
                }}
                viewport={{ once: true }}
                className="sm:w-[564px] w-full sm:h-[300px] h-full sm:bg-gray-100 rounded-3xl sm:border border-gray-200 relative"
              >
                <Image
                  isBlurred
                  alt="about Us image"
                  className="object-cover w-full h-full aspect-video  sm:mt-5 sm:ml-5 rounded-3xl"
                  src="/images/about/about.png"
                />
              </motion.div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
